import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';
import user_img from '../assets/images/user_img.png';
import booking_history from '../assets/images/icons/booking-history.svg';
import profile_img from '../assets/images/icons/profile-img.svg';
import logout from '../assets/images/logout.png';
import family_members from '../assets/images/icons/family-members.svg';
import location from '../assets/images/icons/address-icon-dark.svg';
import booking_active from '../assets/images/icons/booking-icon-active.svg';
import address_active from '../assets/images/icons/address-icon-active.svg';
import family_active from '../assets/images/icons/family-icon-active.svg';
import profile_active from '../assets/images/icons/profile-icon-active.svg';



class Slidemenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <ul className="sidebar-wrapper">
                    <li className="">
                        <div className="my-pofile-detail-box">
                            <div className="profile-icon-box">
                                <img src={user_img} alt="Vikash Gupta" />
                            </div>
                            <div className="profile-detail-box">
                                <h4 className="profile-detail-title bold">Vikash Gupta</h4>
                                <p className="prifile-description">+91 9898989898</p>
                            </div>
                        </div>
                    </li>
                    <span className="sidebar-separator"></span>
                    <li className={(this.props.prop.location.pathname == ROUTES.Booking_History ) ? "active" : ''}>
                        <Link to={ROUTES.Booking_History} title="Booking History">
                            <span className="sidebar-menu-icon account-icon">
                                <img src={booking_history} alt="Booking History" className='icon' />
                                <img src={booking_active} alt="Booking History" className='icon-active' />
                            </span>
                            <span className="sidebar-text">Booking History</span>
                        </Link>
                    </li>
                    <li className={(this.props.prop.location.pathname == ROUTES.ACCOUNT_SETTINGS ) ? "active" : ''}>
                        <Link title="My Profile" to={ROUTES.ACCOUNT_SETTINGS}>
                            <span className="sidebar-menu-icon address-icon">
                                <img src={profile_img} alt="My Profile" className='icon'/>
                                <img src={profile_active} alt="My Profile" className='icon-active' />
                            </span>
                            <span className="sidebar-text">My Profile</span>
                        </Link>
                    </li>
                    <li className={(this.props.prop.location.pathname == ROUTES.FAMILY_MEMBER ) ? "active" : ''}>
                        <Link title="Family Members" to={ROUTES.FAMILY_MEMBER}>
                            <span className="sidebar-menu-icon address-icon">
                                <img src={family_members} alt="Family Members" className='icon'/>
                                <img src={family_active} alt="Family Members" className='icon-active' />
                            </span>
                            <span className="sidebar-text">Family Members</span>
                        </Link>
                    </li>
                    <li className={(this.props.prop.location.pathname == ROUTES.ADDRESSES ) ? "active" : ''}>
                        <Link to={ROUTES.ADDRESSES} title="Addresses">
                            <span className="sidebar-menu-icon address-icon">
                                <img src={location} alt="Address" className='icon'/>
                                <img src={address_active} alt="Address" className='icon-active' />
                            </span>
                            <span className="sidebar-text">Addresses</span>
                        </Link>
                    </li>
                    <li>
                        <Link title="Logout" to={ROUTES.HOME}>
                            <span className="sidebar-menu-icon logout-icon">
                            <img src={logout} alt="My Profile" />
                            </span>
                            <span className="sidebar-text">Logout</span>
                        </Link>
                    </li>
                </ul>
            </>
        );
    }
};

export default Slidemenu;